// * GET =====================================
// TODO(help-content): backend endpoint not built yet - the path (including its
// hardcoded `/api` prefix) is the placeholder HelpContentService always used;
// confirm both on delivery.
export const HELP_GET_CONTENT = (key: string) =>
  `/help/content?key=${encodeURIComponent(key)}`;

// * PATCH ===================================

// * POST ====================================

// * DELETE ==================================

// * PUT =====================================
